import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EducationLoanRoutingModule } from './education-loan-routing.module';
import { EducationLoanComponent } from './education-loan.component';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { DROPZONE_CONFIG } from 'ngx-dropzone-wrapper';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap' ; 
import { CKEditorModule } from 'ngx-ckeditor';

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  maxFilesize: 50,
  url: 'https://httpbin.org/post',
};

@NgModule({
  declarations: [EducationLoanComponent],
  imports: [
    CommonModule,
    EducationLoanRoutingModule,
    Ng2SmartTableModule,
    FormsModule, 
    ReactiveFormsModule,
    DropzoneModule,NgbModule,CKEditorModule
  ],
  providers: [
    {
      provide: DROPZONE_CONFIG,
      useValue: DEFAULT_DROPZONE_CONFIG
    }
  ]
})
export class EducationLoanModule { }
